define('webshopProductsCategoriesListMainCategoryView',[
  'module',
  'underscore',
  'modalsConfirmationView',
  'webshopProductsCategoriesListAutocompleteView',
  'template!webshopProductsCategoriesListMainCategoryView'
], function (
  Module,
  _,
  ConfirmationView,
  AutocompleteView,
  Tpl
) {
  'use strict';

  /**
   * Main (default) category of the product: same autocomplete input as the
   * category cells, click on the chip copies it, the cross clears it.
   */
  Module.exports = AutocompleteView.extend({
    template: Tpl,
    className: 'webshop-products-categories-list-main-category-view ' +
      'webshop-products-categories-list-category-view ' + AutocompleteView.prototype.className,

    ui: _.extend({}, AutocompleteView.prototype.ui, {
      remove: '.chip .remove',
      paste: '.empty .paste'
    }),

    events: _.extend({}, AutocompleteView.prototype.events, {
      'click @ui.chip': 'onCopy',
      'click @ui.remove': 'onRemove',
      'click @ui.paste': 'onPaste'
    }),

    modelEvents: {
      'change:defaultCategoryId': 'render',
      'change:defaultCategoryCode': 'render'
    },

    initialize: function () {
      AutocompleteView.prototype.initialize.apply(this, arguments);
      this.listenTo(this.tableView.clipboard, 'change', this.render);
    },

    getDefaultCategoryId: function () {
      var id = this.model.get('defaultCategoryId');
      return id ? String(id) : '';
    },

    serializeData: function () {
      var id = this.getDefaultCategoryId();
      var clipboard = this.tableView.clipboard;

      return {
        category: id !== '' ? {
          code: this.model.get('defaultCategoryCode'),
          copied: String(clipboard.get('id')) === id
        } : null,
        clipboard: clipboard.get('id') !== '' && String(clipboard.get('id')) !== id ? {
          code: clipboard.get('code')
        } : null
      };
    },

    isExcluded: function (category) {
      return String(category.id) === this.getDefaultCategoryId();
    },

    onSelect: function (category) {
      this.update(this.model.setDefaultCategory(category.id));
    },

    refresh: function () {
      return this.model.fetch();
    },

    onCopy: function (e) {
      e.stopPropagation();
      var id = this.getDefaultCategoryId();
      if (id === '')
        return;

      this.tableView.clipboard.set({
        id: id,
        code: this.model.get('defaultCategoryCode'),
        name: this.model.get('defaultCategoryCode')
      });
    },

    onRemove: function (e) {
      e.stopPropagation();
      if (this.getDefaultCategoryId() === '')
        return;

      ConfirmationView.prototype.open({
        title: _.i18n('webshop.product.defaultCategory.delete.confirmation.title'),
        text: _.i18n('webshop.product.defaultCategory.delete.confirmation.text').replace('%s', this.model.get('code')),
        onConfirm: _.bind(function () {
          this.update(this.model.setDefaultCategory(''));
        }, this)
      });
    },

    onPaste: function (e) {
      e.stopPropagation();
      var id = this.tableView.clipboard.get('id');
      if (id === '' || String(id) === this.getDefaultCategoryId())
        return;

      this.update(this.model.setDefaultCategory(id));
    }
  });
});

